import { Action } from 'redux'
import {
  closedPositionsQuery, // Currency,
  getAllowedLeveragesQuery,
} from '../graphql/schema'
import * as constants from '../constants'
import {
  ViewerWrapper,
  // AccountDetails
} from '../types'

export interface InitGraphQLRepo extends Action {
  type: constants.INIT_GRAPH_QL_REPO
  login?: string
  token?: string
}

export function initGraphQLRepo(token?: string, login?: string): InitGraphQLRepo {
  return {
    type: constants.INIT_GRAPH_QL_REPO,
    login,
    token,
  }
}

export interface GetClosedPositionsAction extends Action {
  type: constants.GET_CLOSED_POSITIONS
  limit: number
}

export function getClosedPositions(limit: number = 110): GetClosedPositionsAction {
  return {
    type: constants.GET_CLOSED_POSITIONS,
    limit,
  }
}

export interface FulfillGetClosedPositionsAction extends Action {
  type: constants.FULFILL_GET_CLOSED_POSITIONS
  closedPosition: closedPositionsQuery
}

export function fulfillGetClosedPositions(
  closedPosition: closedPositionsQuery
): FulfillGetClosedPositionsAction {
  // console.log(closedPosition);
  return {
    type: constants.FULFILL_GET_CLOSED_POSITIONS,
    closedPosition,
  }
}

export interface GetUserTradingAccountsAction extends Action {
  type: constants.GET_USER_TRADING_ACCOUNTS
}

export interface GetUserAccountAction extends Action {
  type: constants.GET_USER_ACCOUNT
  url?: string
  authToken?: string
}

export function getUserAccount(authToken?: string, url?: string): GetUserAccountAction {
  console.log('getUserAccount', authToken, url)
  return {
    type: constants.GET_USER_ACCOUNT,
    url,
    authToken,
  }
}

export function getUserTradingAccounts(): GetUserTradingAccountsAction {
  return {
    type: constants.GET_USER_TRADING_ACCOUNTS,
  }
}

export interface FulfillGetUserTradingAccountsAction extends Action {
  type: constants.FULFILL_USER_ACCOUNT
  viewer: ViewerWrapper
}

export function fulfillUserAccount(account: ViewerWrapper): FulfillGetUserTradingAccountsAction {
  // const stubBondsAccount:AccountDetails = {
  //   "balance": 10000.00,
  //   "currency": Currency.EUR,
  //   "id": 1993604,
  //   "login": "6146599",
  //   "mobile": true,
  //   "serverType": "bonds",
  //   "__typename": "BondVanuatuAccount"
  // };
  // const stubDemoBondsAccount:AccountDetails = {
  //   "balance": 10000.00,
  //   "currency": Currency.EUR,
  //   "id": 1993604,
  //   "login": "6146599",
  //   "mobile": true,
  //   "serverType": "bonds",
  //   "__typename": "BondVanuatuDemoAccount"
  // };
  // account.viewer.accounts.push(stubDemoBondsAccount);
  // account.viewer.accounts.push(stubBondsAccount);

  return {
    type: constants.FULFILL_USER_ACCOUNT,
    viewer: account,
  }
}

export interface GetAllowedLeveragesAction extends Action {
  type: constants.GET_ALLOWED_LEVERAGES
  accountId: number
}

export function getAllowedLeverages(accountId: number): GetAllowedLeveragesAction {
  return {
    type: constants.GET_ALLOWED_LEVERAGES,
    accountId,
  }
}

export interface FulfillGetAllowedLeverages extends Action {
  type: constants.FULFILL_GET_ALLOWED_LEVERAGES
  allowedLeverages: getAllowedLeveragesQuery
}

export function fulfillGetAllowedLeverages(
  allowedLeverages: getAllowedLeveragesQuery
): FulfillGetAllowedLeverages {
  return {
    type: constants.FULFILL_GET_ALLOWED_LEVERAGES,
    allowedLeverages,
  }
}

export interface GetTranslations extends Action {
  type: constants.GET_TRANSLATIONS
}

export function getTranslations(): GetTranslations {
  return {
    type: constants.GET_TRANSLATIONS,
  }
}

export interface GetFavouritesAction extends Action {
  type: constants.GET_FAVOURITES
}

export function getFavourites(): GetFavouritesAction {
  return {
    type: constants.GET_FAVOURITES,
  }
}

export interface FulfillGetFavourites extends Action {
  type: constants.FULFILL_GET_FAVOURITES
  favourites: string[]
}

export function fulfillGetFavourites(favourites: string[]): FulfillGetFavourites {
  return {
    type: constants.FULFILL_GET_FAVOURITES,
    favourites,
  }
}

export interface UpdateFavouritesAction extends Action {
  type: constants.UPDATE_FAVOURITES
  favourites: string[]
}

export function updateFavourites(favourites: string[]): UpdateFavouritesAction {
  return {
    type: constants.UPDATE_FAVOURITES,
    favourites,
  }
}

export interface FulfillUpdateFavourites extends Action {
  type: constants.FULFILL_UPDATE_FAVOURITES
  favourites: string[]
}

export function fulfillUpdateFavourites(favourites: string[]): FulfillUpdateFavourites {
  return {
    type: constants.FULFILL_UPDATE_FAVOURITES,
    favourites,
  }
}

export type GraphQLAction =
  | GetClosedPositionsAction
  | FulfillGetClosedPositionsAction
  | GetUserTradingAccountsAction
  | FulfillGetUserTradingAccountsAction
  | GetAllowedLeveragesAction
  | FulfillGetAllowedLeverages
  | GetTranslations
  | GetFavouritesAction
  | FulfillGetFavourites
  | UpdateFavouritesAction
  | FulfillUpdateFavourites
